import { FormDescriptionTypography } from "./PostForm.styles";
import React from "react";
import { styled } from "@mui/system";
import { Link } from "@mui/material";

const StyledLink = styled(Link)({
    fontWeight: "700",
    textDecoration: "none",
    cursor: "pointer",
    color: "var(--community-color-bright-azure)",
});

export function PostFormInfoText({
    onLastWordDoubleClick,
}: {
    onLastWordDoubleClick: () => void;
}) {
    return (
        <FormDescriptionTypography>
            Beiträge werden vor Veröffentlichung automatisch geprüft. Bei
            Erstellung deines Beitrags erklärst du dich mit den eigenständigen{" "}
            <StyledLink
                onClick={() => {
                    window.open("https://community.check24.de/terms", "_blank");
                }}
            >
                Community Nutzungsbedingungen
            </StyledLink>{" "}
            einverstanden. Bitte beachte die dort aufgeführten{" "}
            <span onDoubleClick={onLastWordDoubleClick}>Verhaltensregeln</span>.
        </FormDescriptionTypography>
    );
}
